import { useScreenSize } from '@/hooks/useScreenSizeDecodo';

export const numberSupportedSections = {
  mobile: 2,
  desktop: 3,
};

export const getComparisonTableDropdownIndices = (
  screenType: 'mobile' | 'desktop'
) => {
  const numberSections = numberSupportedSections[screenType];

  return Array.from(Array(numberSections).keys());
};

export function useComparisonTableDropdownIndices() {
  const { isDesktop } = useScreenSize();

  const numberSections =
    numberSupportedSections[isDesktop ? 'desktop' : 'mobile'];

  return Array.from(Array(numberSections).keys());
}
